export type ResponsiveSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export type MediaQuery<T> = {
  [x in ResponsiveSize]: T;
};

export const responsiveSizesMap: MediaQuery<number> = {
  xs: 600,
  sm: 898,
  md: 1024,
  lg: 1280,
  xl: 1440
};
